import styled from 'styled-components';

export const WelcomeCardContainerV2 = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 380px;
  gap: 16px;
  padding: ${({ noPadding }) => (noPadding ? '0' : '28px')};

  background-color: ${(p) => p.theme.colors.neutral.background};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  > .progress {
    margin: 0;
  }
`;
